export { default } from '@material-ui/icons/Save'; // Link / Launch
